/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dispatch, SetStateAction } from 'react';

export type $TSFixMe = any;

export type BackendResponse<T = unknown> = {
  status: number;
  data: T;
};

export enum Language {
  RU = 'ru',
  EN = 'en',
}

export type InputMode =
  | 'none'
  | 'text'
  | 'tel'
  | 'url'
  | 'email'
  | 'numeric'
  | 'decimal'
  | 'search';
export type EnterKeyHint =
  | 'enter'
  | 'done'
  | 'go'
  | 'next'
  | 'previous'
  | 'search'
  | 'send';

export type ContextType = {
  header: {
    width: number;
    height: number;
    setSize: Dispatch<SetStateAction<{ width: number; height: number }>>;
  };
  screen: {
    isLaptop: boolean;
    setIsLaptop: Dispatch<SetStateAction<boolean>>;
  };
  layoutScroller: {
    trigger: { x: number; y: number };
    scroll: (x?: number, y?: number) => void;
  };
  escHandler: {
    closeModalId: string | undefined;
    addToModalList: (id: string) => void;
    removeFromModalList: (id: string) => void;
    clearCloseModalId: () => void;
  };
  navigator: {
    backUrl: string | null;
    setBackUrl: Dispatch<SetStateAction<string | null>>;
  };
  hcs: {
    hcsIsVisible: boolean;
    toggleHcsIsVisible: () => void;
  };
};

export type PageList = {
  rootUrl: string;
  currentId: string;
  list: { id: string; label: string }[];
};

export type BreadCrumb = { url?: string; label: string } | null;

export interface PaymentsChart {
  time: string;
  date: string;
  numberOfPayments: number;
  total: number;
  system: number;
  qrCode: number;
  reception: number;
  vipAccess: number;
  sessions: number;
}

export type PopUpNotification = {
  uuid: string;
  type: 'success' | 'error';
  title: string;
  timeout: number | null;
};
